import Coordinates from './types/Coordinates';
import DragSignature from './types/DragSignature';

export class DragManager {
    private isDragging = false;

    private lastDragStart: DragSignature = {
        moment: new Date(),
        coordinates: { x: 0, y: 0 },
    };

    private dragStartValues = {
        mouseX: 0,
        mouseY: 0,
        scrollX: 0,
        scrollY: 0,
    };

    constructor(private readonly onDragStart?: (event: PointerEvent) => void) {}

    initializeDrag(event: PointerEvent, currentScroll: Coordinates) {
        this.dragStartValues = {
            mouseX: event.clientX,
            mouseY: event.clientY,
            scrollX: currentScroll.x,
            scrollY: currentScroll.y,
        };

        this.lastDragStart = {
            moment: new Date(),
            coordinates: {
                x: event.clientX,
                y: event.clientY,
            },
        };
    }

    checkDragThreshold(
        event: PointerEvent,
        clickThreshold: number,
        clickTimeThreshold: number
    ): boolean {
        if (this.isDragging) {
            return false;
        }

        const deltaX = event.clientX - this.dragStartValues.mouseX;
        const deltaY = event.clientY - this.dragStartValues.mouseY;
        const delta = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const deltaTimeFromStart =
            new Date().getTime() - this.lastDragStart.moment.getTime();

        if (delta > clickThreshold || deltaTimeFromStart > clickTimeThreshold) {
            this.isDragging = true;
            this.onDragStart?.(event);
            return true;
        }

        return false;
    }

    calculateScrollPosition(event: PointerEvent): Coordinates {
        const deltaX = event.clientX - this.dragStartValues.mouseX;
        const deltaY = event.clientY - this.dragStartValues.mouseY;

        return {
            x: this.dragStartValues.scrollX - deltaX,
            y: this.dragStartValues.scrollY - deltaY,
        };
    }

    reset() {
        this.isDragging = false;
    }

    get isCurrentlyDragging() {
        return this.isDragging;
    }
}

export default DragManager;
